import { Component } from '@angular/core';
import { ZoomOnScrollDirective } from '../../../../shared/directives/zoom-on-scroll.directive';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'landing-our-blog',
    imports: [ZoomOnScrollDirective],
    templateUrl: './our-blog.component.html',
    styleUrl: './our-blog.component.scss'
})
export class LandingOurBlogComponent {
    assetUrl = environment.assetBaseUrl
}
